import { IAppState } from '../../../AppModulesWrapper';

export function selectIsServicesEnabled(state: IAppState): boolean {
  return state.servicePickerWidget.publishTerms.isServicesEnabled;
}
